/** Validates that a string is a member of the given API enum, throwing if unrecognized. */
export function parseEnum<TEnum extends Record<string, string>>(
  value: string,
  enumObject: TEnum,
  enumName: string
): TEnum[keyof TEnum] {
  if (!Object.values(enumObject).includes(value)) {
    throw new Error(`Unknown ${enumName} value: ${value}`)
  }
  return value as TEnum[keyof TEnum]
}
